<template>
    <v-app>
        <people-core-app-bar v-model="expandOnHover" v-if="get_shared_Path === 'People'" />
        <crews-core-app-bar v-model="expandOnHover" v-if="get_shared_Path === 'Crews'" />

        <people-core-drawer :expand-on-hover.sync="expandOnHover" />

        <people-core-view />

        <people-core-footer />
    </v-app>
</template>

<script>
	import { mapGetters } from 'vuex';


    export default {
        name: 'PeopleIndex',

        /* >>> *************************************************************** / /* Components */
        components: {

            PeopleCoreAppBar: () => import('./people/components/core/AppBar'),
            CrewsCoreAppBar: () => import('./crews/components/core/AppBar'),

            PeopleCoreDrawer: () => import('@/components/core/Drawer'), // global
            PeopleCoreView: () => import('@/components/core/View'), // global
            PeopleCoreFooter: () => import('@/components/core/Footer') // global

        }, // eof components{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Data */
        data: () => ({

            expandOnHover: true

        }),
        /* <<< ****************************************************************/


		/* >>> *************************************************************** / /* Computed */
		computed: {

			...mapGetters([
				'get_shared_Path',
			]),

		}, // eo computed{}
		/* <<< ****************************************************************/

    };
</script>
